import _ from "lodash";
import * as XLSX from "xlsx";
import {
    ANDROID_XML_ATTRIBUTE_NAME,
    ANDROID_XML_ATTRIBUTE_TRANSLATABLE,
    ANDROID_XML_TAG_RESOURCES,
    ANDROID_XML_TAG_STRING,
    EXCEL_EXTENSION,
    IOS_RESOURCE_FILENAME,
    KEY,
    TEMPLATE_FILE_NAME
} from "../../constant";
import BaseExcelWriter from "./BaseExcelWriter";

export default class AndroidExcelWriter extends BaseExcelWriter {
    generateFromFile = file => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = event => {
                const document = new DOMParser().parseFromString(event.target.result, file.type);
                if (document.documentElement.nodeName !== ANDROID_XML_TAG_RESOURCES) {
                    return;
                }
                const data = [[KEY, ...this.languageCodes.map(code => code.name)]];
                const nodes = document.documentElement.getElementsByTagName(ANDROID_XML_TAG_STRING);
                for (const node of nodes) {
                    let checkedKey = node.getAttribute(ANDROID_XML_ATTRIBUTE_NAME);
                    if (this.keyMacro) {
                        checkedKey = this.keyMacro(checkedKey);
                        if (typeof checkedKey !== "string" || !checkedKey) {
                            checkedKey = node.getAttribute(ANDROID_XML_ATTRIBUTE_NAME);
                        }
                    }
                    if (!checkedKey) {
                        continue;
                    }
                    let checkedValue = node.textContent;
                    if (this.valueMacro) {
                        checkedValue = this.valueMacro(checkedValue);
                        if (typeof checkedValue !== "string" || !checkedValue) {
                            checkedValue = node.textContent;
                        }
                    }
                    checkedValue = checkedValue.replace(/\\"/g, "\"").replace(/\\'/g, "'").replace(/\\n|([^\\])\\n/g, "$1\n").replace(/\\\\/g, "\\");
                    data.push([checkedKey, checkedValue]);
                }
                const workbook = XLSX.utils.book_new();
                const sheet = XLSX.utils.aoa_to_sheet(data);
                XLSX.utils.book_append_sheet(workbook, sheet, IOS_RESOURCE_FILENAME.replace(".strings", ""));
                resolve(XLSX.writeFile(workbook, `${TEMPLATE_FILE_NAME}.${EXCEL_EXTENSION}`));
            };
            reader.readAsText(file);
        });
    };

    mergeWithFiles = data => {
        return new Promise(resolve => {
            const newData = _.cloneDeep(data);
            const sheetData = newData[IOS_RESOURCE_FILENAME.replace(".strings", "")] || [[KEY]];
            const readActions = [];
            let count = 0;
            const getOnloadHandler = (file, columnIndex) => {
                return event => {
                    const document = new DOMParser().parseFromString(event.target.result, file.type);
                    if (document.documentElement.nodeName !== ANDROID_XML_TAG_RESOURCES) {
                        if (++count >= readActions.length) {
                            newData[IOS_RESOURCE_FILENAME.replace(".strings", "")] = sheetData;
                            resolve(newData);
                        }
                        return;
                    }
                    const nodes = document.documentElement.getElementsByTagName(ANDROID_XML_TAG_STRING);
                    for (const node of nodes) {
                        if (node.getAttribute(ANDROID_XML_ATTRIBUTE_TRANSLATABLE) === "false") {
                            continue;
                        }
                        let checkedKey = node.getAttribute(ANDROID_XML_ATTRIBUTE_NAME);
                        if (this.keyMacro) {
                            checkedKey = this.keyMacro(checkedKey);
                            if (typeof checkedKey !== "string" || !checkedKey) {
                                checkedKey = node.getAttribute(ANDROID_XML_ATTRIBUTE_NAME);
                            }
                        }
                        if (!checkedKey) {
                            continue;
                        }
                        let rowIndex = -1;
                        for (let i = 1; i < sheetData.length; i++) {
                            if (sheetData[i][0] === checkedKey) {
                                rowIndex = i;
                                break;
                            }
                        }
                        let checkedValue = node.textContent;
                        if (this.valueMacro) {
                            checkedValue = this.valueMacro(checkedValue);
                            if (typeof checkedValue !== "string" || !checkedValue) {
                                checkedValue = node.textContent;
                            }
                        }
                        checkedValue = checkedValue.replace(/\\"/g, "\"").replace(/\\'/g, "'").replace(/\\n|([^\\])\\n/g, "$1\n").replace(/\\\\/g, "\\");
                        if (rowIndex < 0) {
                            rowIndex = sheetData.length;
                            const array = [checkedKey];
                            array[columnIndex] = checkedValue;
                            sheetData.push(array);
                        } else {
                            sheetData[rowIndex][columnIndex] = checkedValue;
                        }
                    }
                    if (++count >= readActions.length) {
                        newData[IOS_RESOURCE_FILENAME.replace(".strings", "")] = sheetData;
                        resolve(newData);
                    }
                };
            };
            for (const file of this.files) {
                const language = file.webkitRelativePath.replace(/(.+\/)*(.+)\/.+\.xml$/, "$2");
                const languageCode = this.languageCodes.find(value => value.android === language);
                if (languageCode) {
                    const header = languageCode.name;
                    let columnIndex = sheetData[0].findIndex(value => value === header);
                    if (columnIndex < 0) {
                        columnIndex = sheetData[0].length;
                        sheetData[0].push(header);
                    }
                    const reader = new FileReader();
                    reader.onload = getOnloadHandler(file, columnIndex);
                    readActions.push(() => {
                        reader.readAsText(file);
                    });
                }
            }
            if (readActions.length > 0) {
                for (const action of readActions) {
                    action();
                }
            } else {
                resolve(newData);
            }
        });
    };
}
